// extracted by mini-css-extract-plugin
export default {"size14":"size14-THyue","size16":"size16-vdAqd","size24":"size24-wqJoi","size32":"size32-aV3yc","size40":"size40-iKuXz","size48":"size48-m92aC"};